import { useQueryClient } from "@tanstack/react-query";
import useKlydoMutation, {
  UseKlydoMutationOptions,
} from "../../../../components/hooks/useKlydoMutation";
import adminApiClient from "../../../../api/admin";

/**
 * Opens the CollabPay collaborator for a user who has none. Artists get one by
 * signing the studio contract; brand accounts created from the backoffice need
 * this, or the marketplace publication pass skips every collection they own.
 */
const useCreateCollaboratorMutation = (
  options?: UseKlydoMutationOptions<{ collaboratorId: string }, string>,
) => {
  const queryClient = useQueryClient();
  return useKlydoMutation({
    mutationKey: ["create-user-collaborator"],
    mutationFn: (userId: string) =>
      adminApiClient.createUserCollaborator(userId),
    ...options,
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries({ queryKey: ["users"] });
      options?.onSuccess?.(data, variables, context);
    },
  });
};

export default useCreateCollaboratorMutation;
